"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.avatar = void 0;
var avatar = {
  sizes: {
    xs: 24,
    s: 28,
    m: 40,
    xxl: 112
  },
  fontSizes: {
    xs: 9,
    s: 10,
    m: 13,
    xxl: 32
  },
  colors: {
    0: '#9fa1a7',
    1: '#E8473E',
    2: '#ff7314',
    3: '#28D239',
    4: '#249DDA',
    5: '#BD4325',
    6: '#19C2B9',
    7: '#BD3259',
    8: '#3D6DE8',
    9: '#d0a41a',
    10: '#829712',
    11: '#F87C85',
    12: '#E83FC7',
    13: '#3AAA6D',
    14: '#E8952F',
    15: '#B07FFF',
    16: '#AB1AA2',
    17: '#6aa635',
    18: '#F51D51',
    19: '#D3741C',
    20: '#8637e4',
    21: '#7B1FAD',
    22: '#491FAD',
    23: '#1FAD68',
    24: '#B41C00',
    25: '#1F7EAD',
    26: '#f1af04',
    27: '#FE5E52',
    28: '#874F52',
    29: '#73ae8b',
    30: '#6F7D90'
  }
};
exports.avatar = avatar;